import React from 'react';
import PropTypes from 'prop-types';

const UperCaseRenderer = (props) => {
  const value = props.value;

  return (
    <span>{typeof value === 'string' ? value.toUpperCase() : value}</span>
  );
};

UperCaseRenderer.propTypes = {
  value: PropTypes.string
};

export default UperCaseRenderer;
